import { getLastElement } from './array';
import { replaceHttpWithHttps } from './parseUrl';
import { openNewWindow } from './window';

export const readFileData = (file, handleLoad) => {
  const reader = new FileReader();
  reader.onload = handleLoad;
  reader.readAsDataURL(file);
};

export const parseXMLNodeValue = (xml, node) => {
  const parsedResponse = new DOMParser().parseFromString(xml, 'application/xml');

  return parsedResponse?.getElementsByTagName(node)?.[0]?.childNodes?.[0]?.nodeValue;
};

export const blobToFile = (theBlob, fileName) => {
  const file = theBlob;
  // A Blob() is almost a File() - it's just missing the two properties below which we will add
  file.lastModifiedDate = new Date();
  file.name = fileName;

  // Cast to a File() type
  return file;
};

const downloadFileFromBlob = (blob, fileName) => {
  const blobUrl = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.download = fileName;
  a.href = blobUrl;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.parentNode.removeChild(a);
};

export const downloadFile = (data, fileName) => {
  const blob = new Blob([data]);
  return downloadFileFromBlob(blob, fileName);
};

export const downloadFromURL = (url, fileId) =>
  openNewWindow(
    `${process.env.REACT_APP_API_URL}proxyDownload/${fileId}/${encodeURIComponent(replaceHttpWithHttps(url))}`
  );

export const isImage = file => file?.type?.split?.('/')?.[0] === 'image';

export const isFile = element => element && element instanceof File;

export const getFileExtension = fileName => {
  const parts = fileName.split('.');
  return parts.length > 1 ? getLastElement(parts) : '';
};

export const formatBytes = bytes => {
  if (bytes === 0) {
    return '0 Bytes';
  }

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  const formattedValue = (bytes / Math.pow(k, i)).toFixed(2);

  return `${formattedValue} ${sizes[i]}`;
};
